import React from 'react';
import { useIntl, type MessageDescriptor } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../components/primitives/SMLButton';
import { useProfileUpgrade } from '../useProfileUpgrade';
import { profileMessages as m } from '../profileMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ProfileUpgradeButtonProps {
  /** The label of the owner button ("Upgrade", "Upgrade to send to Spotify"). */
  label?: MessageDescriptor;
  small?: boolean;
}

/** The upgrade of the owner, or "Ask the owner to upgrade" for a member (no checkout, D11). */
const ProfileUpgradeButtonComponent: React.FC<ProfileUpgradeButtonProps> = ({ label = m.upgrade, small = false }) => {
  const intl = useIntl();
  const { isMember, upgrade } = useProfileUpgrade();
  if (isMember) {
    return (
      <span className={styles.meta} data-testid="profile-ask-owner">
        {intl.formatMessage(m.askOwner)}
      </span>
    );
  }
  return (
    <SMLButton variant="primary" className={small ? styles.sm : undefined} onClick={upgrade}>
      {intl.formatMessage(label)}
    </SMLButton>
  );
};

export const ProfileUpgradeButton = TypedMemo(ProfileUpgradeButtonComponent);
